import img from "@/assets/candidates/sky-company.png";

const TESTIMONIALS_CUSTOM_STYLES = {
  bgColor: "bg-jacarta",
  txtColor: "text-white",
  authorColor: "text-green",
};

const SIGN = {
  color: "text-green",
  value: "?",
};

const CUSTOM_STYLES = {
  txtColor: "text-green",
  accordionHeader: "text-light-grey",
  cntColor: "text-purple",
  iconColor: "black",
  customClass: "candidate-accordion",
  accord_open: "jaccord_open",
  accord_close: "jaccord_close",
};

const TITLE_STYLES = {
  title: "What does our process look like",
  titleColor: "text-purple max-w-[667px] text-center self-center",
};

const ARROW_STYLES = {
  bgColor: "bg-pink",
  strokeStyles: "[&>path]:fill-white [&>path]:stroke-white",
};

export {
  TESTIMONIALS_CUSTOM_STYLES,
  SIGN,
  CUSTOM_STYLES,
  TITLE_STYLES,
  ARROW_STYLES,
};
